/**
 * Subscription Price block — mirrors the Mask Subscription Box state.
 * Listens for the `msb:change` event dispatched by mask-subscription-box.js
 * and updates price, compare-at price, % off badge, and the Shop Pay
 * installments (payment terms) variant.
 *
 * The document-level listener is registered at script evaluation (not on
 * DOMContentLoaded) so the box's initial dispatch is never missed.
 */
(() => {
  const formatMoney = (cents) => `$${(Number(cents || 0) / 100).toFixed(2)}`;

  const update = (root, detail) => {
    if (!detail) return;

    // Only sync with a box selling the same product (when both declare one).
    const productId = root.getAttribute('data-product-id');
    if (productId && detail.productId && String(productId) !== String(detail.productId)) return;

    const priceEl = root.querySelector('[data-sp-price]');
    const compareWrap = root.querySelector('[data-sp-compare-wrap]');
    const compareEl = root.querySelector('[data-sp-compare]');
    const badgeEl = root.querySelector('[data-sp-badge]');

    const priceCents = Number(detail.priceCents || 0);
    const compareCents = Number(detail.compareCents || 0);
    const showCompare = compareCents > priceCents;

    if (priceEl) priceEl.textContent = formatMoney(priceCents);
    if (compareWrap) compareWrap.hidden = !showCompare;
    if (compareEl && showCompare) compareEl.textContent = formatMoney(compareCents);

    if (badgeEl) {
      const percentOff = Number(detail.percentOff || 0);
      badgeEl.hidden = !(percentOff > 0);
      if (percentOff > 0) badgeEl.textContent = `${percentOff}% OFF`;
    }

    // Keep Shop Pay installments pointed at the selected variant. Note:
    // installments always quote the variant's one-time price — Shop Pay
    // has no notion of the subscription discount.
    if (detail.variantId) {
      const idInput = root.querySelector('.payment-terms input[name="id"]');
      if (idInput) idInput.value = detail.variantId;

      const terms = root.querySelector('shopify-payment-terms');
      if (terms) terms.setAttribute('variant-id', detail.variantId);
    }
  };

  document.addEventListener('msb:change', (event) => {
    document.querySelectorAll('[data-subscription-price]').forEach((root) => {
      update(root, event.detail);
    });
  });
})();
